/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

//import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IObrienPerformanceChartsData } from './obrien-performance-charts.data';
import { IObrienPerformanceChartsProps,  } from './obrien-performance-charts.props.autogenerated';


export interface IObrienPerformanceChartsViewProps extends IObrienPerformanceChartsProps<IObrienPerformanceChartsData> {


    row1Columns?: string[];
    row2Columns?: string[];
    row3Columns?: string[];
    row4Columns?: string[];
    row5Columns?: string[];
    row6Columns?: string[];
    row7Columns?: string[];
    row8Columns?: string[];
}

/**
 *
 * ObrienPerformanceCharts component
 * @extends {React.PureComponent<IObrienPerformanceChartsProps<IObrienPerformanceChartsData>>}
 */
class ObrienPerformanceCharts extends React.PureComponent<IObrienPerformanceChartsProps<IObrienPerformanceChartsData>> {

    public render(): JSX.Element | null {

        const { config } = this.props;

        const Row1Columns = config.row1Columns;
        const Row2Columns = config.row2Columns;
        const Row3Columns = config.row3Columns;
        const Row4Columns = config.row4Columns;
        const Row5Columns = config.row5Columns;
        const Row6Columns = config.row6Columns;
        const Row7Columns = config.row7Columns;
        const Row8Columns = config.row8Columns;

        const viewprops = {
            ...this.props,
            
            row1Columns: Row1Columns,
            row2Columns: Row2Columns,
            row3Columns: Row3Columns,
            row4Columns: Row4Columns,
            row5Columns: Row5Columns,
            row6Columns: Row6Columns,
            row7Columns: Row7Columns,
            row8Columns: Row8Columns,

        }



        return this.props.renderView(viewprops);
    }

    











}

export default ObrienPerformanceCharts;
